export default "__VITE_ASSET__BI2rlvnw__"